import React from "react";
import { Box, Chip, Stack, useTheme } from "@mui/material";

/*
Filter Tabs Component
---------------------
Category filter tabs for blog posts
*/

const CATEGORIES = [
  "All",
  // 'Design',
  // 'AI',
  "Product",
  "Engineering",
  "Infra",
];

function FilterTabs({ activeFilter, onFilterChange }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        overflowX: "auto",
        py: 2,
        "&::-webkit-scrollbar": {
          height: "6px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: `${theme.palette.primary.main}0D`, // main color at 5% opacity
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: `${theme.palette.primary.main}33`, // main color at 20% opacity
          borderRadius: "3px",
        },
      }}
    >
      <Stack direction="row" spacing={2} sx={{ minWidth: "max-content" }}>
        {CATEGORIES.map((category) => (
          <Chip
            key={category}
            label={category}
            onClick={() => onFilterChange(category)}
            sx={{
              backgroundColor:
                activeFilter === category
                  ? `${theme.palette.primary.tertiary}33` // tertiary (#17D1FA) at 20% opacity
                  : `${theme.palette.primary.main}08`, // main color at 3% opacity
              border:
                activeFilter === category
                  ? `2px solid ${theme.palette.primary.tertiary}` // tertiary (#17D1FA)
                  : `2px solid ${theme.palette.primary.main}33`, // main color at 20% opacity
              color:
                activeFilter === category
                  ? theme.palette.primary.tertiary // tertiary (#17D1FA)
                  : theme.palette.text.primary,
              fontFamily: "Montserrat",
              fontSize: { xs: "0.875rem", sm: "1rem" },
              fontWeight: activeFilter === category ? 600 : 500,
              px: 2,
              py: 2.5,
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor:
                  activeFilter === category
                    ? `${theme.palette.primary.tertiary}40` // tertiary (#17D1FA) at 25% opacity
                    : `${theme.palette.primary.main}14`, // main color at 8% opacity
                borderColor:
                  activeFilter === category
                    ? theme.palette.primary.tertiary // tertiary (#17D1FA)
                    : `${theme.palette.primary.main}4D`, // main color at 30% opacity
              },
            }}
          />
        ))}
      </Stack>
    </Box>
  );
}

export default FilterTabs;
